module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"versionsNotAligned":"Measure comparison is not possible for older ESG questionnaires with a different questionnaire logic."},"de":{"versionsNotAligned":"Der Vergleich der ESG-Maßnahmen ist für ältere Fragebögen-Versionen nicht möglich, da sich die Fragebogenlogik geändert hat."}}')
  delete Component.options._Ctor
}
